import options from './desk-occupancy.component';

export default {
    selector: "dtEmulatorDeskOccupancy",
    options
}